import SurveyShowTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function SurveyShowPage() {
  const { result } = useTypedSelector((state) => state.Survey);

  return (
    <S.Container>
      <PageTitle title={result?.data?.title || 'Survey results'} />
      <SurveyShowTable data={result.data} loading={result.loading} />
    </S.Container>
  );
}
